<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="7.2934mm" height="6.2104mm" version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 1058.34 893.2" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">        
        <g id="Camada_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer" />
            <path style="fill: #f58634; fill-rule: nonzero;"
                d="M529.14 893.2c-5.13,0 -10.24,-1.5 -14.69,-4.62 -333.66,-230.7 -514.45,-393.48 -514.45,-592.86 0,-165.84 121.92,-295.72 277.52,-295.72 137.93,0 215.87,91.62 251.62,150.21 35.8,-58.55 113.82,-150.21 251.66,-150.21 155.62,0 277.53,129.88 277.53,295.72 0,199.37 -180.8,362.15 -514.43,592.86 -4.47,3.12 -9.6,4.62 -14.76,4.62z" />
    </g>
</svg></template>
